import React from 'react';
import spinner from 'assets/Spinner.svg';
import styles from './UploadCSVModal.module.scss';
// import { useEffect } from 'react';

const CsvStepTwo = ({ apiRes, setApiRes }) => {

  // useEffect(()=>{setApiRes([])},[])

  return (
    <div className={styles.containerStep}>

    { apiRes && apiRes.length ? 
      <>
        
        <div className={styles.timeline}>

          <div className={styles.step}>
            <h6>Upload CSV</h6>
            <div className={`${styles.circle} ${styles.completed}`}></div>
          </div>

          <div className={styles.step}>
            <h6>Review Upload</h6>
            <div className={`${styles.circle} ${styles.currentStage}`}></div>
          </div>

          <div className={styles.step}>
            <h6>Review Import</h6>
            <div className={styles.circle}></div>
          </div>

          <div className={styles.step}>
            <h6>Create Student</h6>
            <div className={styles.circle}></div>
          </div>

          <div className={styles.line}>
            <div className={styles.blueLine}></div>
          </div>

        </div>


        <h3>Review Uploaded Data</h3>

        <p>If any of the details are incorrect, please go back to your CSV file and update the values, making sure to use this order for the columns: First Name, Last Name, Grade, Student Email (optional), Parent Email (optional), and upload it again.</p>


        <div className={styles.csvTable}>

          <div className={styles.headers}>
            <div className={styles.headerDropdown}> First Name </div>
            <div className={styles.headerDropdown}> Second Name </div>
            <div className={styles.headerDropdown}> Grade </div>
            <div className={styles.headerDropdown}> Student Email </div>
            <div className={styles.headerDropdown}> Parent Email </div>
          </div>

          <div className={styles.dataRows}>
            {
              apiRes.map((item, idx) =>  {
                return(
                  <div className={styles.dataRow}>
                    <div className={styles.dataColumn}>{item.first_name}</div>
                    <div className={styles.dataColumn}>{item.last_name}</div>
                    <div className={styles.dataColumn}>{item.grade}</div>
                    <div className={styles.dataColumn}>{item.student_email}</div>
                    <div className={styles.dataColumn}>{item.parentemail}</div>
                  </div>
                )
              })
            }
          </div>

        </div>
      </>

    :
    
        <div className={styles.loader}>
          <img src={spinner} alt="spinner"/>
          <h6>Processing CSV...</h6>
        </div>
    
    }



    </div>

  )

}

export default CsvStepTwo;






  // const rowData = [
  //   {
  //     first_name:'Johnny',
  //     last_name:'Smith',
  //     grade:5,
  //     student_email:'johnny@bw.com',
  //     parentemail:'parent@bw.com'
  //   },
  //   {
  //     first_name:'Johnny',
  //     last_name:'Smith',
  //     grade:5,
  //     student_email:'johnny@bw.com',
  //     parentemail:'parent@bw.com'
  //   },
  //   {
  //     first_name:'Johnny',
  //     last_name:'Smith',
  //     grade:5,
  //     student_email:'johnny@bw.com',
  //     parentemail:'parent@bw.com'
  //   },
  //   {
  //     first_name:'Johnny',
  //     last_name:'Smith',
  //     grade:5,
  //     student_email:'johnny@bw.com',
  //     parentemail:'parent@bw.com'
  //   },
  //   {
  //     first_name:'Johnny',
  //     last_name:'Smith',
  //     grade:5,
  //     student_email:'johnny@bw.com',
  //     parentemail:'parent@bw.com'
  //   },
  //   {
  //     first_name:'Johnny',
  //     last_name:'Smith',
  //     grade:5,
  //     student_email:'johnny@bw.com',
  //     parentemail:'parent@bw.com'
  //   },
  //   {
  //     first_name:'Johnny',
  //     last_name:'Smith',
  //     grade:5,
  //     student_email:'johnny@bw.com',
  //     parentemail:'parent@bw.com'
  //   },
  //   {
  //     first_name:'Johnny',
  //     last_name:'Smith',
  //     grade:5,
  //     student_email:'johnny@bw.com',
  //     parentemail:'parent@bw.com'
  //   },
  //   {
  //     first_name:'Johnny',
  //     last_name:'Smith',
  //     grade:5,
  //     student_email:'johnny@bw.com',
  //     parentemail:'parent@bw.com'
  //   },
  //   {
  //     first_name:'Johnny',
  //     last_name:'Smith',
  //     grade:5,
  //     student_email:'johnny@bw.com',
  //     parentemail:'parent@bw.com'
  //   },
  //   {
  //     first_name:'Johnny',
  //     last_name:'Smith',
  //     grade:5,
  //     student_email:'johnny@bw.com',
  //     parentemail:'parent@bw.com'
  //   },
  //   {
  //     first_name:'Johnny',
  //     last_name:'Smith',
  //     grade:5,
  //     student_email:'johnny@bw.com',
  //     parentemail:'parent@bw.com'
  //   },
  // ]
